import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";

const isDisableRange = (
  dataType,
  role,
  entireBatchRejectedByPro,
  isDataRejectedByProcessor,
  parameterData,
  entireBatchRejectedByInvestigatorMappingValidator,
  isDataRejectedByInvestigatorMappingValidator,
) => {
  let disable = false;
  if (role === "validator") {
    disable = true;
    return disable;
  } else if (role === "preProcessor") {
    const rangeDrivenDatatypes = ["numeric", "percentage"];
    if (!rangeDrivenDatatypes.includes(dataType)) {
      disable = true;
    }

    if (!entireBatchRejectedByPro) {
      if (isDataRejectedByProcessor) {
        let isAnyCellRejected = parameterData?.mappings?.some(
          (ele) => ele?.processorCellRejection?.isRejected,
        );

        disable =
          isAnyCellRejected || parameterData?.processorRowRejection?.isRejected
            ? false
            : true;
      }
    }

    if (!entireBatchRejectedByInvestigatorMappingValidator) {
      if (isDataRejectedByInvestigatorMappingValidator) {
        let isAnyCellRejected = parameterData?.mappings?.some(
          (ele) => ele?.investigatorMappingValidatiorCellRejection?.isRejected,
        );

        disable =
          isAnyCellRejected ||
          parameterData?.investigatorMappingValidatiorRowRejection?.isRejected
            ? false
            : true;
      }
    }

    return disable;
  } else {
    // if (parameterData?.isNewAddedByPro) {
    const rangeDrivenDatatypes = ["numeric", "percentage"];
    if (!rangeDrivenDatatypes.includes(dataType)) {
      disable = true;
    } else disable = false;
    // } else disable = true;

    return disable;
  }
};

const RangeSelector = (props) => {
  const {
    handleRange,
    parameterIndex,
    dataType,
    selectedRange,
    role,
    entireBatchRejectedByPro,
    isDataRejectedByProcessor,
    parameterData,
    entireBatchRejectedByInvestigatorMappingValidator,
    isDataRejectedByInvestigatorMappingValidator,
  } = props;

  const [range, setRange] = useState({ min: "", max: "" });

  useEffect(() => {
    setRange({
      ...selectedRange,
    });
  }, [selectedRange]);

  const handleRangeChange = (value, type) => {
    setRange({
      ...range,
      [type]: value,
    });
  };

  const inputStyle = {
    textAlign: "center", // Center align the text in the TextField
  };

  return (
    <>
      <TextField
        className="textfieldClass"
        type="number"
        placeholder={"Min"}
        onBlur={(e) => handleRange(e.target.value, parameterIndex, "min")}
        inputProps={{ style: inputStyle }} // Apply the text alignment style
        disabled={isDisableRange(
          dataType,
          role,
          entireBatchRejectedByPro,
          isDataRejectedByProcessor,
          parameterData,
          entireBatchRejectedByInvestigatorMappingValidator,
          isDataRejectedByInvestigatorMappingValidator,
        )}
        value={range?.min}
        onChange={(e) => handleRangeChange(e.target.value, "min")}
      />
      -
      <TextField
        className="textfieldClass"
        type="number"
        placeholder={"Max"}
        onBlur={(e) => handleRange(e.target.value, parameterIndex, "max")}
        inputProps={{ style: inputStyle }} // Apply the text alignment style
        disabled={isDisableRange(
          dataType,
          role,
          entireBatchRejectedByPro,
          isDataRejectedByProcessor,
          parameterData,
          entireBatchRejectedByInvestigatorMappingValidator,
          isDataRejectedByInvestigatorMappingValidator,
        )}
        value={range?.max}
        onChange={(e) => handleRangeChange(e.target.value, "max")}
      />
    </>
  );
};

export default RangeSelector;
